import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IProfile } from "pages/Profile";

export interface ProfileState {
  item?: IProfile;
  loaded: boolean;
}

const initialState: ProfileState = { loaded: false };

const profileSlice = createSlice({
  name: "profile",
  initialState,
  reducers: {
    fetchProfile(state, action: PayloadAction<IProfile>) {
      state.item = action.payload;
      state.loaded = true;
    },
  },
});

export const { fetchProfile } = profileSlice.actions;

export default profileSlice.reducer;
